import { configureStore } from '@reduxjs/toolkit';
import { emptySplitApi } from './services/base/emptySplitApi';
import tokenReducer from './reduxActions/tokenSlice';
import alertReducer from './reduxActions/alert';
import themeReducer from './reduxActions/theme'
import responseMiddleware from './services/base/responseMiddleware';
import authUserReducer from './services/slices/authUserSlice';
import { canvaEmptySplitApi } from './services/base/canvaEmptySplitApi';

export const store = configureStore({
  reducer: {
    token: tokenReducer,
    alerts: alertReducer,
    theme: themeReducer,
    [emptySplitApi.reducerPath]: emptySplitApi.reducer,
    [canvaEmptySplitApi.reducerPath]:
      canvaEmptySplitApi.reducer,
    authUser: authUserReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable values
        ignoredActions: [
          'api/executeQuery/fulfilled',
          'api/executeQuery/rejected',
          'api/canva/executeQuery/fulfilled',
          'api/canva/executeQuery/rejected',
        ],
        // Ignore non-serializable values
        ignoredPaths: [
          'api.queries',
          'api.mutations',
          'api/canva.queries',
          'api/canva.mutations',
        ],
      },
    }).concat(
      emptySplitApi.middleware,
      canvaEmptySplitApi.middleware,
      responseMiddleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
